module.exports = __webpack_public_path__ + "static/img/meet-the-team_2.0707d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/meet-the-team_2.png
// module id = JewC
// module chunks = 0